export type TourPlacement = "top" | "bottom" | "left" | "right";

export const DEFAULT_PLACEMENT: TourPlacement = "bottom";

// ── Anchor ──────────────────────────────────────────────

export interface AnchorMeta {
  borderRadius?: string;
}

// ── Storage ─────────────────────────────────────────────

export interface TourGuideStorage {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
}

// ── Step & tour definitions ─────────────────────────────

export interface TourStepDefinition {
  anchorName: string;
  textKey: string;
  textVars?: Record<string, unknown>;
  buttonTextKey?: string;
  runBefore?: () => void | Promise<void>;
  runAfter?: () => void | Promise<void>;
  placement?: TourPlacement;
}

export interface TourDefinition {
  id: string;
  resolveSteps: () => TourStepDefinition[];
}

// ── Cubit state ─────────────────────────────────────────

export interface TourGuideState {
  activeTourId: string | null;
  currentStepIndex: number;
  steps: TourStepDefinition[];
  isTransitioning: boolean;
}
